import FocusableInput from '@components/FocusableInput';
import { usePatientResidentRegistrationNumberContext } from '@context/PatientResidentRegistrationNumber';
import { RRN_INPUT } from '../../../focuskey';
const ButtonContainer = () => {
  const { registrationNumber, refineRRN, focusCompleteButton } =
    usePatientResidentRegistrationNumberContext();

  return (
    <FocusableInput
      focusKey={RRN_INPUT}
      value={registrationNumber}
      maxLength={14}
      onEnterPress={focusCompleteButton}
      onChange={refineRRN}
      placeholder="주민등록번호 13자리를 입력하세요."
    />
  );
};

export default ButtonContainer;
